module.exports = "<terms-form></terms-form>";